import { IonSpinner } from "@ionic/react";
import React from "react";
import { default as report_icon } from "../../../AE2/static/icons/customer_page/Recent Activity/Extra Report - Light Blue.svg";
import { default as download_icon } from "../../../AE2/static/icons/download-icon.svg";

interface Props {
  title: string;
  loading: boolean;
  onClick: () => void;
}

/** Report download row used in the customer dashboard Reports card */
const ReportRow: React.FC<Props> = ({ title, loading, onClick }) => (
  <button
    type="button"
    className="cd-report-row"
    style={{ width: "100%", border: "none", textAlign: "left", cursor: "pointer" }}
    disabled={loading}
    onClick={onClick}
  >
    <img src={report_icon} alt="" />
    <div className="cd-report-title">{title}</div>
    {loading ? (
      <IonSpinner style={{ width: "20px", height: "20px" }} />
    ) : (
      <img src={download_icon} alt="Download" style={{ width: "20px", height: "20px" }} />
    )}
  </button>
);

export default ReportRow;
